import { IIndicatorCategory } from "types/graphqlTypes";

export default function getCategoryOrder(category: IIndicatorCategory) {
  return [
    IIndicatorCategory.IncomeStatement,
    IIndicatorCategory.BalanceSheet,
    IIndicatorCategory.CashFlow,
    IIndicatorCategory.Payout,
    IIndicatorCategory.Ratios,
    IIndicatorCategory.Metrics,
    IIndicatorCategory.Fundamentei,
    IIndicatorCategory.Other,
  ].indexOf(category);
}
